import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Contact from '../home/components/Contact';
import WhatsAppDiagnostic from '../home/components/WhatsAppDiagnostic';

export default function ReparationFenetrePVCLyon() {
  const services = [
    {
      icon: 'ri-tools-line',
      title: 'Remplacement Vitrage PVC',
      description: 'Remplacement de vitrage cassé, fissuré ou embué. Double et triple vitrage haute performance.',
      price: 'À partir de 150€'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Réparation Mécanismes',
      description: 'Réparation et remplacement de poignées, crémones, gâches et systèmes d\'ouverture.',
      price: 'À partir de 80€'
    },
    {
      icon: 'ri-ruler-line',
      title: 'Ajustement Ouvrants',
      description: 'Réglage précis des ouvrants, correction des défauts d\'alignement et d\'étanchéité.',
      price: 'À partir de 60€'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Étanchéité Renforcée',
      description: 'Remplacement des joints, traitement anti-infiltration et isolation optimale.',
      price: 'À partir de 70€'
    },
    {
      icon: 'ri-lock-line',
      title: 'Sécurisation Fenêtres',
      description: 'Installation de systèmes anti-effraction, serrures multipoints et vitrages sécurisés.',
      price: 'À partir de 120€'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Rénovation Complète',
      description: 'Remise à neuf complète de vos fenêtres PVC avec garantie décennale.',
      price: 'Sur devis'
    }
  ];

  const advantages = [
    {
      icon: 'ri-time-line',
      title: 'Intervention Rapide',
      description: 'Dépannage sous 24h à Lyon et sa région'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Garantie Décennale',
      description: 'Tous nos travaux sont garantis 10 ans'
    },
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Devis Gratuit',
      description: 'Estimation précise sans engagement'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Conseil Expert',
      description: '15 ans d\'expérience en menuiserie PVC'
    }
  ];

  const faqItems = [
    {
      question: 'Combien coûte la réparation d\'une fenêtre PVC à Lyon ?',
      answer: 'Le prix varie selon le type de réparation : de 60€ pour un simple ajustement à 300€+ pour un remplacement de vitrage complet. Nous proposons un devis gratuit pour une estimation précise.'
    },
    {
      question: 'Quels sont les problèmes courants des fenêtres PVC ?',
      answer: 'Les problèmes fréquents incluent : vitrage embué ou cassé, mécanismes défaillants, joints usés, problèmes d\'étanchéité, difficultés d\'ouverture/fermeture, et infiltrations d\'air ou d\'eau.'
    },
    {
      question: 'Faut-il remplacer ou réparer une fenêtre PVC ?',
      answer: 'Dans 80% des cas, la réparation est possible et plus économique. Nous évaluons l\'état de vos fenêtres et vous conseillons la meilleure solution selon votre situation et votre budget.'
    },
    {
      question: 'Intervenez-vous rapidement en cas d\'urgence ?',
      answer: 'Oui, nous proposons un service d\'intervention rapide sous 24h pour les urgences (vitrage cassé, problème de sécurité). Contactez-nous au 04 78 XX XX XX.'
    },
    {
      question: 'Quelle est la durée de vie d\'une fenêtre PVC réparée ?',
      answer: 'Une fenêtre PVC bien réparée et entretenue peut durer 20 à 30 ans supplémentaires. Nos réparations sont garanties 10 ans pour votre tranquillité.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 via-teal-500 to-cyan-400 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-map-pin-line text-white"></i>
              <span className="text-white text-sm font-medium">Lyon et sa région - Rhône (69)</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Réparation Fenêtre PVC Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Expert en réparation de fenêtres PVC à Lyon. Intervention rapide, devis gratuit et garantie décennale. Remplacement de vitrage, réparation de mécanismes et ajustement d'ouvrants.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-white text-teal-600 px-8 py-4 rounded-full font-bold hover:bg-gray-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Devis Gratuit Immédiat
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="tel:0478XXXXXX"
                className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-full font-bold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                04 78 XX XX XX
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-teal-600 font-semibold text-xs uppercase tracking-wider">
              NOS PRESTATIONS
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mt-3 mb-4">
              Services de Réparation Fenêtre PVC
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Solutions complètes pour tous vos problèmes de fenêtres PVC à Lyon
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-400 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="pt-4 border-t border-gray-100">
                  <span className="text-teal-600 font-bold text-lg">{service.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
              Pourquoi Nous Choisir ?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {advantages.map((advantage, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${advantage.icon} text-teal-600 text-3xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {advantage.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {advantage.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Expert en Réparation de Fenêtres PVC à Lyon
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Spécialiste de la <strong>réparation de fenêtres PVC à Lyon</strong>, nous intervenons rapidement pour tous vos problèmes de menuiserie. Que ce soit pour un vitrage cassé, un mécanisme défaillant ou un problème d'étanchéité, notre équipe d'experts vous apporte des solutions durables et garanties.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Les Avantages des Fenêtres PVC
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les fenêtres PVC sont particulièrement appréciées à Lyon pour leurs nombreux avantages : excellente isolation thermique et phonique, entretien minimal, résistance aux intempéries et longévité exceptionnelle. Cependant, même les meilleures fenêtres PVC peuvent nécessiter des réparations au fil du temps.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Problèmes Courants et Solutions
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Vitrage embué ou cassé :</strong> Remplacement rapide avec double vitrage haute performance</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Mécanismes défaillants :</strong> Réparation ou remplacement de poignées, crémones et systèmes d'ouverture</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Problèmes d'étanchéité :</strong> Remplacement des joints et traitement anti-infiltration</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Difficultés d'ouverture :</strong> Ajustement précis des ouvrants et réglage des charnières</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Notre Zone d'Intervention à Lyon
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Nous intervenons dans tout Lyon et sa région : Lyon 1er, 2ème, 3ème, 4ème, 5ème, 6ème, 7ème, 8ème, 9ème, Villeurbanne, Caluire-et-Cuire, Vaulx-en-Velin, Vénissieux, Saint-Priest, Bron, Meyzieu, Décines-Charpieu, Rillieux-la-Pape, Oullins, et toutes les communes du Rhône (69).
            </p>
          </article>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
              Questions Fréquentes
            </h2>
            <p className="text-gray-600 text-lg">
              Tout ce que vous devez savoir sur la réparation de fenêtres PVC
            </p>
          </div>

          <div className="space-y-6">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all"
              >
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-start">
                  <i className="ri-question-line text-teal-600 text-xl mr-3 mt-1"></i>
                  {item.question}
                </h3>
                <p className="text-gray-700 leading-relaxed ml-9">
                  {item.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
